import { Injectable, Inject } from '@angular/core';
import { AppConfig } from '../app-config';
import { APP_CONFIG } from '../app-config.token';
import { EmploymentHistoryRecordDto } from '../models/dtos/employment-history-record-dto';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class EmploymentHistoryRecordService {
  private readonly API_URL = this.config.resourceApiURI + '/employmentHistoryRecord';

  constructor(private http: HttpClient, @Inject(APP_CONFIG) private config: AppConfig) {}

  getEmploymentHistoryRecordById(employmenyHistoryRecordId: number): Observable<EmploymentHistoryRecordDto> {
    const url = `${this.API_URL}/${employmenyHistoryRecordId}`;
    return this.http.get<EmploymentHistoryRecordDto>(url).pipe(
      map(
        (a) =>
          <EmploymentHistoryRecordDto>{
            ...a,
            EmploymentDateFrom: a.EmploymentDateFrom && new Date(a.EmploymentDateFrom + 'Z'),
            EmploymentDateTo: a.EmploymentDateTo && new Date(a.EmploymentDateTo + 'Z'),
          },
      ),
    );
  }

  setTemporaryWorkEmployer(employmentHistoryRecordId: number, temporaryWorkEmployerId: number) {
    const url = `${this.API_URL}/${employmentHistoryRecordId}/setTemporaryWorkEmployer`;
    return this.http.post(url, temporaryWorkEmployerId );
  }
}
